<svg *ngIf="iconId" [ngClass]="iconClass">
  <!-- empty xlink:href attribute must exist for the ng-attr to work properly since this attribute has a colon -->
  <use [attr.xlink:href]="iconId" xlink:href=""></use>
</svg>